import React from 'react';
import { styled } from 'linaria/react';
import { convertPropsToObject } from '../ContentRender/ContentRender';
import TextContent from '../ui/TextContent';
import ReadMore from '../Util/ReadMore';

const Wrapper = styled.div`
  max-width: 700px;
  margin: 3rem auto 0;
`;

const BottomContent = ({ category }) => {
  const data = category?.data?.items.filter(
    item => item.type === 'category-bottom-content'
  )[0];

  if (!data) return null;

  const content = convertPropsToObject(data);
  const text = content.text?.value;

  return (
    <Wrapper>
      <ReadMore breakPoint={200} maxHeight={150} icon={true}>
        <TextContent content={text} />
      </ReadMore>
    </Wrapper>
  );
};

export default BottomContent;
